import { FC } from 'react';
import { Tooltip } from 'antd';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';
import { IoIosInformationCircleOutline } from 'react-icons/io';
import { ComparisonIndicator, formatIndicatorValue } from './overview.model';
import styles from './overview.module.less';

interface IndicatorCellProps {
  indicator: ComparisonIndicator;
}

const CHIP_CLASS = {
  positive: styles.chipPositive,
  negative: styles.chipNegative,
  neutral: styles.chipNeutral,
};

const IndicatorCell: FC<IndicatorCellProps> = ({ indicator }) => {
  const { label, tooltip, value, unit, delta, caret, tone, teamAvg } = indicator;

  const renderCaret = () => {
    if (caret === 'down') return <FaCaretDown />;
    if (caret === 'up') return <FaCaretUp />;
    return <span className={styles.noDelta}>-</span>;
  };

  return (
    <div className={styles.indicator}>
      <span className={styles.indicatorLabel}>
        {label}
        <Tooltip title={tooltip}>
          <span className={styles.infoIconWrap}>
            <IoIosInformationCircleOutline className={styles.infoIcon} />
          </span>
        </Tooltip>
      </span>
      <span className={styles.indicatorValue}>{formatIndicatorValue(value, unit)}</span>

      <div className={styles.comparison}>
        <span className={`${styles.comparisonChip} ${CHIP_CLASS[tone]}`}>{renderCaret()}</span>
        <span className={styles.comparisonText}>
          {delta === null ? '— vs last period' : `${formatIndicatorValue(delta, unit)} vs last period`}
        </span>
      </div>

      <span className={styles.teamAvg}>
        Team avg <b>{formatIndicatorValue(teamAvg, unit)}</b>
      </span>
    </div>
  );
};

interface YouVsTeamAverageProps {
  indicators: ComparisonIndicator[];
}

const YouVsTeamAverage: FC<YouVsTeamAverageProps> = ({ indicators }) => (
  <div className={`${styles.card} ${styles.teamCard}`}>
    <div className={styles.cardHeader}>You vs team average</div>
    <div className={styles.indicators}>
      {indicators.map((indicator) => (
        <IndicatorCell key={indicator.key} indicator={indicator} />
      ))}
    </div>
  </div>
);

export default YouVsTeamAverage;
